/* import __COLOCATED_TEMPLATE__ from './staff-premium-upsell-modal.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { assert } from '@ember/debug';
import { PlanToken } from '@dashboard/shared-ui/services/staff/staff-subscriptions';
let StaffPremiumUpsellModal = (_class = class StaffPremiumUpsellModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "staffSubscriptions", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _initializerDefineProperty(this, "dataApi", _descriptor3, this);
    _defineProperty(this, "onClose", this.args.onClose);
    _initializerDefineProperty(this, "showModal", _descriptor4, this);
  }
  trackStaffPremiumUpsellEvent(eventName) {
    if (this.args.trigger) {
      if (this.args.trigger?.description === 'Upgrade Modal' || this.args.trigger?.description === 'Settings') {
        this.dataApi.track(eventName, {
          page_click_detail: this.args.trigger.detail
        });
      } else {
        assert(`Unknown upsell event trigger ${JSON.stringify(this.args.trigger)}`);
      }
    } else {
      this.dataApi.track(eventName);
    }
  }
  navigateToPricing() {
    this.trackStaffPremiumUpsellEvent('Staff Premium: View Pricing');
    window.open('/dashboard/staff/plans', '_blank');
  }
  navigateToFeatures() {
    this.trackStaffPremiumUpsellEvent('Staff Premium: View Features');
    window.open('/dashboard/staff/pricing', '_blank');
  }
  async CTAClick() {
    this.showModal = false;
    this.trackStaffPremiumUpsellEvent('Staff Premium: Upgrade Modal');
    const {
      didSubscribe
    } = await this.staffSubscriptions.openSingleCheckoutModal({
      planToken: PlanToken.STAFF_PREMIUM,
      locationPlanToken: PlanToken.STAFF_PREMIUM_PER_LOCATION
    });
    if (didSubscribe) {
      this.args.onSuccessHandler?.();
    } else {
      this.showModal = true;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "staffSubscriptions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, "navigateToPricing", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToPricing"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToFeatures", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToFeatures"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "CTAClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "CTAClick"), _class.prototype), _class);
export { StaffPremiumUpsellModal as default };